// @flow

import React, { Component } from 'react'
import styled from 'styled-components'

import Book from './Book/Book'
import PreviewBook from './PreviewBook/PreviewBook'

const Root = styled.div`
  position: relative;

  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;

  margin: 0 auto;
  max-width: 960px;
`

type Props = {
  bookLocales: Array<string>
};

type State = {
  selectedLocale: string
}

class Books extends Component {
  state: State;
  props: Props;

  state = {
    selectedLocale: '',
  }

  handleViewClick = (locale: string) => {
    this.setState({ selectedLocale: locale })
  }

  handlePreviewClose = () => {
    this.setState({ selectedLocale: '' })
  }

  render() {
    const { selectedLocale } = this.state;
    const { bookLocales } = this.props;

    return (
      <Root>
        {bookLocales.map((locale, index) => (
          <Book
            key={index}
            onViewClick={this.handleViewClick}
            locale={locale}
          />
        ))}
        {selectedLocale !== '' && (
          <PreviewBook
            locale={selectedLocale}
            onClose={this.handlePreviewClose}
          />
        )}
      </Root>
    )
  }
}

export default Books



// WEBPACK FOOTER //
// ./src/components/Books.js